/*
 * Copyright (c) 2008-2019 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */

/**
 * Generate a uniformly distributed random integer within the range <min> .. <max>.
 *   (min) - Lower limit: random >= min (default: 0)
 *   (max) - Upper limit: random <= max (default: 1)
 */
// this was originally part of UUID.js in the old client
 const randomInt = function (min, max) {
	if (!isFinite(min)) {
		min = 0;
	}
	if (!isFinite(max)) {
		max = 1;
	}
	return (Math.floor((Math.random() % 1) * (max - min + 1) + min));
};

Math.randomInt = randomInt

export {randomInt};
